<style scoped>
.el-aside {
    display: flex;
    justify-content: center;
    align-items: center;
}

section {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
}

.logo {
    width: 40px;
}

.headerLogo {
    cursor: pointer;
}
.logo {
    cursor: pointer;
}
</style>

<template>
    <el-container>
        <el-aside width="auto" class="header-logo tap">
            <img class="logo" src="../assets/logo.png" alt="Logo" />
        </el-aside>
        <el-dropdown>
            <span class="el-dropdown-link">
                你好！{{accountName}}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="signOut()">注销</el-dropdown-item>
                <el-dropdown-item>修改密码</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </el-container>
</template>

<script>
import app from "@/App.vue"

import {apiSignOut} from '@/request/api';

export default {
    data() {
        return {
            activeIndex: "1",
            accountName: app.globalData.userInfo.accountName
        };
    },
    methods: {
        handleSelect(key, keyPath) {
            console.log(key, keyPath);
        },
        signOut() {
            apiSignOut({
                
            }).then(res => {
                var status = res.status;
                var msg = res.msg;
                if (status === '2') {
                    this.$message.error(msg);
                } else {
                    this.$message.success("注销成功");
                    this.$router.push("/").catch(error => error);
                    app.signOut();
                }
            })
        }
        
    }
}
</script>


// WEBPACK FOOTER //
// src/components/nav-top.vue